





































import { Component, Provide, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TStation } from '@/plugins/podolib/services/entities/EntityStations';
// Components
import DialogAcquisitionInProgress from '@/components/dialogs/DialogAcquisitionInProgress.vue';
import DialogStartAnalysisWithoutConnectedStation from '@/components/dialogs/DialogStartAnalysisWithoutConnectedStation.vue';

@Component({
  components: {
    DialogAcquisitionInProgress,
    DialogStartAnalysisWithoutConnectedStation,
  },
})
export default class HomeWelcome extends Vue {
  @Provide() acquisitionInProgressDialog: boolean = false;
  @Provide() noStationAvailableDialog: boolean = false;

  get doctor() {
    return this.$pdc.doctor?.current;
  }

  // Has connected station ?
  get connectedStations() {
    return this.$pdc.analysis!.entityStations?.data.filter((x: TEntity<TStation>) => x.online).length;
  }

  openEquipementsGetKit() {
    this.$pdc.bus!.emit('equipments:get-kit:open');
  }

  startAcquisition() {
    if (this.$pdc.analysis!.manifestHasData) {
      this.acquisitionInProgressDialog = true;
    } else if (!this.connectedStations!) {
      this.noStationAvailableDialog = true;
    } else {
      // Analytics
      // this.$pdc.analytics?.actions.trackSuccess('Home Welcome NewAnalysis Click');
      this.$emit('startAcquisition');
    }
  }

  // Close dialogs
  closeAnalysisDialog() {
    this.acquisitionInProgressDialog = false;
  }
  closeNoStationDialog() {
    this.noStationAvailableDialog = false;
  }
}
